import { render } from "./CurrentAuctionsAvailableWidget.vue?vue&type=template&id=a1f50b9e&scoped=true&ts=true"
import script from "./CurrentAuctionsAvailableWidget.vue?vue&type=script&lang=ts"
export * from "./CurrentAuctionsAvailableWidget.vue?vue&type=script&lang=ts"

import "./CurrentAuctionsAvailableWidget.vue?vue&type=style&index=0&id=a1f50b9e&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f50b9e"]])

export default __exports__